module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ios-overlay",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "ios-modal"
  }, [_c('h3', [_vm._v("Install StumptheSpread")]), _vm._v(" "), _c('p', {
    staticClass: "ios-subtitle"
  }, [_vm._v("Push notifications require the app to be installed on your home screen.")]), _vm._v(" "), _c('div', {
    staticClass: "ios-steps"
  }, [_c('div', {
    staticClass: "ios-step"
  }, [_c('div', {
    staticClass: "ios-step-number"
  }, [_vm._v("1")]), _vm._v(" "), _c('div', {
    staticClass: "ios-step-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "ios-share-icon"
  }, [_c('svg', {
    attrs: {
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "#e94560",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "16 6 12 2 8 6"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "2",
      "x2": "12",
      "y2": "15"
    }
  })])])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('button', {
    staticClass: "ios-dismiss",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_vm._v("Got it")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Tap the "), _c('strong', [_vm._v("Share")]), _vm._v(" button in Safari")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ios-step"
  }, [_c('div', {
    staticClass: "ios-step-number"
  }, [_vm._v("2")]), _vm._v(" "), _c('div', {
    staticClass: "ios-step-content"
  }, [_c('p', [_vm._v("Scroll down and tap "), _c('strong', [_vm._v("\"Add to Home Screen\"")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ios-step"
  }, [_c('div', {
    staticClass: "ios-step-number"
  }, [_vm._v("3")]), _vm._v(" "), _c('div', {
    staticClass: "ios-step-content"
  }, [_c('p', [_vm._v("Tap "), _c('strong', [_vm._v("\"Add\"")]), _vm._v(" in the top right")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ios-step"
  }, [_c('div', {
    staticClass: "ios-step-number"
  }, [_vm._v("4")]), _vm._v(" "), _c('div', {
    staticClass: "ios-step-content"
  }, [_c('p', [_vm._v("Open "), _c('strong', [_vm._v("StumptheSpread")]), _vm._v(" from your home screen")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ios-step"
  }, [_c('div', {
    staticClass: "ios-step-number"
  }, [_vm._v("5")]), _vm._v(" "), _c('div', {
    staticClass: "ios-step-content"
  }, [_c('p', [_vm._v("Come back here to "), _c('strong', [_vm._v("enable notifications")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ios-arrow-container"
  }, [_c('div', {
    staticClass: "ios-arrow"
  }, [_vm._v("↓")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-90b9bc3c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/IOSInstallGuide.vue
// module id = 302
// module chunks = 1